import { jsx as _jsx } from "react/jsx-runtime";
import styled, { css } from 'styled-components';
export default function Badge({ size = 'medium', value, state = 'info', className = '', }) {
    return (_jsx(Container, { className: `${className} ui-badge`, size: size, state: state, children: _jsx("span", { children: value }) }));
}
export const Container = styled.div `
  display: flex;
  align-items: center;
  position: relative;
  padding: 4px 5px 3px 5px;
  border-radius: 3px;
  color: var(--text-primary);
  font-size: 10px;
  line-height: 10px;
  font-weight: bold;

  ${props => props.size === 'big' && css `
    font-size: 12px;
    /* line-height: 12px; */
    padding-right: 6px;
    padding-left: 6px;
  `}

  ${props => props.state === 'success' && css `
    background-color: var(--colors-green);
  `}

  ${props => props.state === 'info' && css `
    background-color: var(--accent-blue);
  `}

  ${props => props.state === 'warning' && css `
    background-color: var(--warning-color);
  `}
`;
